export default [
    {
        icon: 'GridIcon',
        route: 'patient-info',
        title: 'Patient info'
    },
]
